import React from 'react';
import { X, Calendar, User, Tag } from 'lucide-react';

interface BlogPreviewProps {
  title: string;
  content: string;
  tags?: string[];
  author?: string;
  coverImage?: string;
  onClose: () => void;
}

export const BlogPreview: React.FC<BlogPreviewProps> = ({
  title,
  content,
  tags = [],
  author = 'Admin User',
  coverImage,
  onClose,
}) => {
  // Format current date for display
  const formattedDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="bg-white min-h-screen">
      {/* Preview Header */}
      <div className="bg-gray-100 p-4 sticky top-0 z-10 border-b border-gray-200">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <h2 className="text-lg font-medium text-gray-800">Preview Mode</h2>
          <button
            onClick={onClose}
            className="flex items-center text-gray-600 hover:text-gray-900 bg-white px-3 py-1.5 rounded-md border border-gray-300 text-sm"
          >
            <X className="h-4 w-4 mr-1" />
            Exit Preview
          </button>
        </div>
      </div>

      {/* Blog Content */}
      <div className="max-w-4xl mx-auto p-6">
        {/* Cover Image (if available) */}
        {coverImage && (
          <div className="mb-8">
            <img 
              src={coverImage} 
              alt={title} 
              className="w-full h-64 object-cover rounded-lg"
            />
          </div>
        )}

        {/* Title */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4">{title}</h1>

        {/* Meta Info */}
        <div className="flex flex-wrap items-center text-sm text-gray-600 mb-8">
          <div className="flex items-center mr-6 mb-2">
            <User className="h-4 w-4 mr-1" />
            <span>{author}</span>
          </div>
          <div className="flex items-center mb-2">
            <Calendar className="h-4 w-4 mr-1" />
            <span>{formattedDate}</span>
          </div>
        </div>

        {/* Tags */}
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap mb-8">
            {tags.map((tag, index) => (
              <div 
                key={index}
                className="flex items-center bg-blue-100 text-blue-800 text-xs px-3 py-1.5 rounded-full mr-2 mb-2"
              >
                <Tag className="h-3 w-3 mr-1" />
                {tag}
              </div>
            ))}
          </div>
        )}

        {/* Content */}
        <div className="prose max-w-none">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  );
};